var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gfu-project-summary-action gfu-media" },
    [
      _c("base-icon", {
        staticClass: "gfu-project-summary-action__side _tc--accent",
        attrs: { name: "unlock" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "gfu-media__body" }, [
        _c("h5", { staticClass: "gfu-hd gfu-hd--h4 _ma-0" }, [
          _vm._v(
            _vm._s(_vm.Resources.ProjectHome.ProjectSummaryStretchGoalUnlocked)
          ),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "gfu-link gfu-link--accent",
            attrs: {
              href: _vm.stretchGoalsUrl,
              "data-qa": "view-stretch-goals-link",
            },
          },
          [
            _vm._v(
              _vm._s(_vm.Resources.ProjectHome.ProjectSummaryStretchGoalsLink)
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }